define('drops/runtimeQueryBuilder/runtimeQueryBuilder',[
    'jquery',
    'underscore',
    'lq',
    'lq/frontendModules',
    'lq/drop',
], function ($, _, lq, FrontendModules, Drop) {
    'use strict';

    var builderData = null;

    var RuntimeQueryBuilder = function (options) {
        Drop.call(this, $('<div>'), options);
    };

    Drop.extend(RuntimeQueryBuilder, Drop);

    RuntimeQueryBuilder.typeName = 'RuntimeQueryBuilder';

    RuntimeQueryBuilder.prototype.preRender = function () {
        this.applyPosition();
    };

    RuntimeQueryBuilder.prototype.postRender = function () {
        if (this.data.showEmptyQueryOnPageLoad) {
            this.setValue({
                value: "{}"
            });
        }
    };

    RuntimeQueryBuilder.prototype.getValue = function () {
        return this.lastDesignState;
    };

    RuntimeQueryBuilder.prototype.clearValue = $.noop;

    RuntimeQueryBuilder.prototype.setValue = function (update) {
        var designData = update.value;

        FrontendModules.load('runtimeQueryBuilder', true)
            .then(this.showComponent.bind(this, designData));
    };

    RuntimeQueryBuilder.prototype.showComponent = function (designData, QueryBuilder) {
        if (!builderData) {
            var self = this;
            $.get(lq.getTenantUrl('Query/BuilderData'),
                function (data) {
                    builderData = data;
                    self.showQueryBuilder(designData, QueryBuilder);
                });
        } else {
            this.showQueryBuilder(designData, QueryBuilder);
        }
    };

    RuntimeQueryBuilder.prototype.showQueryBuilder = function (designState, QueryBuilder) {
        this.lastDesignState = designState;

        var self = this;
        QueryBuilder.default({
            baseUrl: lq.getBaseUrl(''),
            tenant: lq.getTenantName(),
            application: lq.getTenantApplicationName(),
            state: designState ? JSON.parse(designState) : {},
            componentName: lq.getNameOfComponent(),
            frontEndUrl: lq.getFrontEndUrl(''),
            tenantUrl: lq.getTenantUrl(''),
            entities: builderData.entities,
            externalData: {
                availableQueries: []
            },
            save: function (query, designData) {
                self.lastDesignState = JSON.stringify(designData);
                self.triggerEventIfEnabled('saveClicked');
            },
            cancel: function () {
                self.triggerEventIfEnabled('cancelClicked');
            }
        }, this.$element.get(0));
    };

    return RuntimeQueryBuilder;
});
